import equals from 'fast-deep-equal'

import * as util from './util'

export function exclusiveMaximum(reference, data) {
  if (reference == null) {
    return true
  }

  return data < reference
}

export function exclusiveMinimum(reference, data) {
  if (reference == null) {
    return true
  }

  return data > reference
}

export function maximum(reference, data) {
  if (reference == null) {
    return true
  }

  return data <= reference
}

export function minimum(reference, data) {
  if (reference == null) {
    return true
  }

  return data >= reference
}

export function multipleOf(reference, data) {
  if (reference == null) {
    return true
  }

  return data % reference === 0
}

export function maxLength(reference, data) {
  if (reference == null) {
    return true
  }

  return data.length <= reference
}

export function maxProperties(reference, data) {
  return maxLength(reference, Object.keys(data))
}

export function minLength(reference, data) {
  if (reference == null) {
    return true
  }

  return data.length >= reference
}

export function minProperties(reference, data) {
  return minLength(reference, Object.keys(data))
}

export function pattern(reference, data) {
  if (reference == null) {
    return true
  }

  const re = new RegExp(reference)
  return re.test(data)
}

export function type(reference, data) {
  if (reference == null) {
    return true
  }

  switch (reference) {
    case 'null': {
      return data === null
    }
    case 'boolean':
    case 'number':
    case 'string': {
      return typeof data === reference
    }
    case 'integer': {
      return parseInt(data, 10) === data
    }
    case 'array': {
      return Array.isArray(data)
    }
    case 'object': {
      return (
        data != null &&
        typeof data === 'object' &&
        Array.isArray(data) === false
      )
    }
    default: {
      throw new Error(`Unknown type "${reference}"`)
    }
  }
}

export function uniqueItems(reference, data) {
  if (reference == null) {
    return true
  }

  if (reference) {
    for (let i = data.length - 1; i >= 0; i--) {
      const index = data.indexOf(data[i])
      if (index > -1 && index < i) {
        return false
      }
    }
  }

  return true
}

export function values(reference, data) {
  if (reference == null) {
    return true
  }

  return util.any(x => equals(data, x), reference)
}

export function value(reference, data) {
  if (reference == null) {
    return true
  }

  return values([reference], data)
}
